const openRedirectAllowedDomains = [/^(.*\.)?calm\.com$/i, /^(.*\.)?atlasapp\.site$/i];

/**
 * Validates a redirect target to defend against open-redirect attacks. Returns
 * the target if it is a same-origin path or points to a trusted Calm domain.
 * Otherwise, returns "/" so callers never forward the user to an attacker.
 *
 * Rejects protocol-relative URLs (e.g. "//evil.com"), non-http(s) schemes
 * (e.g. "javascript:", "data:"), and unknown hosts.
 */
export const protectOpenRedirect = (target: string): string => {
	if (typeof target !== 'string' || target.length === 0) {
		return '/';
	}
	if (target.length > 1 && (target[1] === '/' || target[1] === '\\') && target[0] === '/') {
		return '/';
	}
	if (target.startsWith('/')) {
		return target;
	}
	try {
		const parsedUrl = new URL(target);
		if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
			return '/';
		}
		const isAllowed = openRedirectAllowedDomains.some(allowedDomainRegexp =>
			allowedDomainRegexp.test(parsedUrl.hostname),
		);
		if (!isAllowed) {
			return '/';
		}
		return target;
	} catch {
		return '/';
	}
};
